import React from 'react'

import { ISalaryData } from './salary/salary.interface'

type GuaranteedAmountContextProps = {
  salaries: Array<ISalaryData>
  setSalaries: (data: Array<ISalaryData>) => void
}

const GuaranteedAmountContext = React.createContext<GuaranteedAmountContextProps>({
  salaries: [],
  setSalaries: () => {},
})

export const GuaranteedAmountProvider = GuaranteedAmountContext.Provider
export const GuaranteedAmountConsumer = GuaranteedAmountContext.Consumer
export default GuaranteedAmountContext
